import { BREAKPOINT } from '../../constants';

class MelHeader extends HTMLElement {
  constructor(self) {
    self = super(self);
    this._scrolling = false;
    this._headerOffset = 30;
    this._lastPosition = 0;
    return self;
  }

  static get is() {
    return 'mel-header';
  }

  /**
   * Getter for `hide` attribute
   */
  get hide() {
    return this.hasAttribute('hide');
  }

  /**
   * Setter for `hide` attribute
   */
  set hide(value) {
    if (Boolean(value)) {
      this.setAttribute('hide', '');
    } else {
      this.removeAttribute('hide');
    }
  }

  connectedCallback() {
    this._bindHandlers();
    window.addEventListener('scroll', this._handleScroll, false);
  }

  disconnectedCallback() {
    window.addEventListener('scroll', this._handleScroll, false);
  }

  _bindHandlers() {
    this._autoHide = this._autoHide.bind(this);
    this._handleScroll = this._handleScroll.bind(this);
  }

  _handleScroll(evt) {
    if (!this._scrolling) {
      this._scrolling = true;
      'requestAnimationFrame' in window
        ? requestAnimationFrame(this._autoHide)
        : setTimeout(this._autoHide, 50);
    }
  }

  _autoHide() {
    const currentPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;

    document.body.classList.toggle('header-is-fixed', currentPosition >= this._headerOffset);

    this._scrolling = false;
  }
}

customElements.define(MelHeader.is, MelHeader);
